import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Styled confirmation modal to replace window.confirm() for destructive actions.
 * Usage:
 *   <ConfirmModal
 *     open={open}
 *     title="Delete listing?"
 *     message="This can't be undone."
 *     confirmLabel="Delete"
 *     onConfirm={handleConfirm}
 *     onCancel={handleCancel}
 *     danger  // optional — makes confirm button red
 *   />
 */
export default function ConfirmModal({ open, title, message, confirmLabel = 'Confirm', cancelLabel = 'Cancel', onConfirm, onCancel, danger = false }) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className="modal-overlay"
      onClick={onCancel}
    >
      <div
        className="modal-box"
        style={{ maxWidth: 420 }}
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <span style={{ fontWeight: 700, fontSize: '1rem', color: 'var(--gray-900)' }}>
            {title}
          </span>
          <button
            onClick={onCancel}
            style={{ background: 'none', border: 'none', fontSize: '1.3rem', cursor: 'pointer', color: 'var(--gray-500)', lineHeight: 1 }}
          >×</button>
        </div>

        {message && (
          <div className="modal-body" style={{ color: 'var(--gray-600)', fontSize: '0.9rem', lineHeight: 1.55 }}>
            {message}
          </div>
        )}

        <div className="modal-footer">
          <button className="btn btn-ghost btn-md" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            className={`btn btn-md ${danger ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
